import frTranslations from '../locales/fr.json';
import enTranslations from '../locales/en.json';

const translations = {
  fr: frTranslations,
  en: enTranslations
};

/**
 * Fonction de traduction
 * @param {string} lang - Code de langue ('fr' ou 'en')
 * @param {string} key - Clé de traduction (ex: 'common.appName')
 * @param {object} params - Paramètres optionnels pour remplacer les placeholders
 * @returns {string} - Texte traduit
 */
export const t = (lang = 'fr', key, params = {}) => {
  // Utiliser 'fr' par défaut si la langue n'est pas supportée
  const language = lang && translations[lang] ? lang : 'fr';
  
  // Obtenir les traductions pour la langue
  const langTranslations = translations[language] || translations.fr;
  
  // Diviser la clé en parties (ex: 'common.appName' -> ['common', 'appName'])
  const keys = key.split('.');
  
  // Naviguer dans l'objet de traduction
  let value = langTranslations;
  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k];
    } else {
      // Si la clé n'existe pas, essayer en anglais comme fallback
      if (language !== 'en') {
        const enValue = translations.en;
        let fallbackValue = enValue;
        for (const fallbackKey of keys) {
          if (fallbackValue && typeof fallbackValue === 'object' && fallbackKey in fallbackValue) {
            fallbackValue = fallbackValue[fallbackKey];
          } else {
            // Si même en anglais ça n'existe pas, retourner la clé
            return key;
          }
        }
        value = fallbackValue;
      } else {
        // Si on est déjà en anglais et que ça n'existe pas, retourner la clé
        return key;
      }
    }
  }
  
  // Si la valeur est une chaîne, remplacer les placeholders
  if (typeof value === 'string') {
    let result = value;
    // Remplacer les placeholders {{key}}
    Object.keys(params).forEach(paramKey => {
      const regex = new RegExp(`{{\\s*${paramKey}\\s*}}`, 'g');
      result = result.replace(regex, params[paramKey]);
    });
    
    // Gérer les pluriels simples ({{plural}} -> 's' ou '')
    if (result.includes('{{plural}}')) {
      const count = params.count || 0;
      result = result.replace(/\{\{plural\}\}/g, count > 1 ? 's' : '');
    }
    
    return result;
  }
  
  // Si ce n'est pas une chaîne, retourner la valeur (tableau/objet)
  if (value !== undefined) {
    return value;
  }

  return key;
};

export default t;

